import {useQuery} from '@apollo/react-hooks';

import type {
    GetRelatedEmailAddresses as GetRelatedEmailAddressesQuery,
    GetRelatedEmailAddressesVariables as GetRelatedEmailAddressesQueryVariables,
} from 'nutshell-graphql-types';

import GET_RELATED_EMAIL_ADDRESSES from './graphql/queries/get-related-email-addresses.graphql';

export const useGetEntityEmailAddresses = (entityId?: string | null, shouldSkip?: boolean) => {
    const {data, loading} = useQuery<
        GetRelatedEmailAddressesQuery,
        GetRelatedEmailAddressesQueryVariables
    >(GET_RELATED_EMAIL_ADDRESSES, {
        variables: {
            // @ts-expect-error
            id: entityId,
        },
        skip: shouldSkip || !entityId,
        fetchPolicy: 'cache-and-network',
    });

    const coreEntity = data ? data.coreEntity : null;

    return {
        entity: coreEntity,
        isLoadingRelatedEmails: loading,
    };
};
